import { ICouponFilter } from '../interfaces';

export function createCouponsFilter(formData: any): ICouponFilter {
  const filter: ICouponFilter = {
    page: formData.pagination.page,
    filter: formData.filter,
    limit: formData.pagination.limit,
    statusId: formData.status ? formData.status.id : null,
    sort: formData.sort,
    userId: formData.username ? formData.username.id : null,
  };

  return filter;
}
